/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderProcessingInfoTrackingApiModel } from './order-processing-info-tracking';

export interface OrderProcessingInfoApiModel {
  /**
   * Assistance trouble type (only if status is \'customer-assistance-needed\')
   */
  assistance_type?: OrderProcessingInfoApiModelAssistanceTypeEnum | null;
  /**
   * Estimated delivery date and time
   */
  estimated_delivery?: string | null;
  /**
   * Order status
   */
  status?: OrderProcessingInfoApiModelStatusEnum | null;
  tracking?: OrderProcessingInfoTrackingApiModel | null;
}
export enum OrderProcessingInfoApiModelAssistanceTypeEnum {
  FuelCapLocked = 'fuel-cap-locked',
  VehicleNotFound = 'vehicle-not-found'
}
export enum OrderProcessingInfoApiModelStatusEnum {
  Pending = 'pending',
  Shipping = 'shipping',
  CustomerAssistanceNeeded = 'customer-assistance-needed'
}
